/* Browser toolbars may resize the visible viewport while the page is scrolling. */
(function () {
  if (!document.body.classList.contains('template-index') ||
      !document.querySelector('.HomeSlideshow') || window.__bfCampaignViewport) return;
  window.__bfCampaignViewport = true;

  var root = document.documentElement;
  var property = '--campaign-stable-window-height';
  var safeBottomProperty = '--campaign-stable-safe-bottom';
  var lastWidth = 0;
  var scheduled = false;
  var orientationChanged = false;

  function measureSmallViewport() {
    if (window.CSS && window.CSS.supports('height', '100svh')) {
      var probe = document.createElement('div');
      probe.setAttribute('aria-hidden', 'true');
      probe.style.cssText = 'position:fixed!important;top:0!important;left:0!important;width:0!important;height:100svh!important;padding:0!important;border:0!important;visibility:hidden!important;pointer-events:none!important;';
      document.body.appendChild(probe);
      var height = probe.getBoundingClientRect().height;
      probe.remove();
      if (height > 0) return height;
    }
    return Math.min(window.innerHeight || Infinity, root.clientHeight || Infinity,
      (window.visualViewport && window.visualViewport.height) || Infinity);
  }

  function measureSafeBottom() {
    var probe = document.createElement('div');
    probe.setAttribute('aria-hidden', 'true');
    probe.style.cssText = 'position:fixed!important;width:0!important;height:0!important;padding:0!important;padding-bottom:env(safe-area-inset-bottom, 0px)!important;border:0!important;visibility:hidden!important;pointer-events:none!important;';
    document.body.appendChild(probe);
    var bottom = parseFloat(window.getComputedStyle(probe).paddingBottom) || 0;
    probe.remove();
    return Math.max(0, bottom);
  }

  function sync(force) {
    var width = root.clientWidth || window.innerWidth;
    if (!width) return;
    if (width > 1180) {
      root.style.removeProperty(property);
      root.style.removeProperty(safeBottomProperty);
      lastWidth = width;
      return;
    }
    if (!force && width === lastWidth) return;
    var height = Math.round(measureSmallViewport());
    if (!isFinite(height) || height <= 0) return;
    root.style.setProperty(property, height + 'px');
    root.style.setProperty(safeBottomProperty, measureSafeBottom() + 'px');
    lastWidth = width;
  }

  function schedule(event) {
    if (event && event.type === 'orientationchange') orientationChanged = true;
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      var force = orientationChanged;
      orientationChanged = false;
      sync(force);
    });
  }

  sync(false);
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('orientationchange', schedule, { passive: true });
  window.addEventListener('pageshow', schedule);
})();

(function () {
  if (!document.body.classList.contains('template-index') || !window.matchMedia || window.__bfCampaignBackground) return;
  window.__bfCampaignBackground = true;
  var desktop = window.matchMedia('(min-width: 1181px)');
  var property = '--bf-campaign-backdrop';

  function init(root) {
    root.querySelectorAll('.HomeSlideshow:not(#section-slideshow) .HomeSlideshow__Media, .BFCompleteLook .HomeSlideshow__Media').forEach(function (media) {
      if (media.dataset.bfCampaignFrame === 'true') return;
      media.dataset.bfCampaignFrame = 'true';
      function sync() {
        var photo = media.querySelector('img');
        if (!desktop.matches || !photo || !photo.complete || !photo.naturalWidth) {
          media.style.removeProperty(property);
          return;
        }
        var source = photo.currentSrc || photo.src;
        media.style.setProperty(property, 'url(' + JSON.stringify(source) + ')');
      }
      var observer = new MutationObserver(sync);
      observer.observe(media, { attributes: true, attributeFilter: ['src', 'srcset', 'media'], childList: true, subtree: true });
      media.addEventListener('load', sync, true);
      desktop.addEventListener('change', sync);
      var section = media.closest('.shopify-section');
      if (section) section.addEventListener('shopify:section:unload', function () {
        observer.disconnect();
        media.removeEventListener('load', sync, true);
        desktop.removeEventListener('change', sync);
      }, { once: true });
      sync();
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
